import React from "react";
import { Row, Col } from "reactstrap";
import Dropzone from "react-dropzone";
import { cross_icn } from "../../../images";
import { Container, Fade } from "react-bootstrap";
const SmallScreen = ({
  fileLink,
  maxFiles,
  accept,
  url,
  closeUrlEvent,
  urlImage,
  urlImageHandle,
  onDropImage,
  linkClickEvent,
}) => {
  return (
    <>
      <Row className="d-flex flex-xs-row ">
        <Col xs={12} sm={12} md={url ? 6 : 12} className="order-2 order-xs-1 mb-2">
          <div className="convert_select_area">
            <div className="con_select_panel" style={{ height: "90px" }}>
              <Dropzone
                onDrop={onDropImage}
                maxFiles={maxFiles}
                accept={accept}
              >
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps({ className: "drg_input" })}>
                    <input {...getInputProps()} />
                  </div>
                )}
              </Dropzone>

              <div className="slct_panel_content">
                <div style={{ display: "block" }}>
                  <span className="drg_title me-1">Drag & Drop</span>
                </div>
                <span className="drag_text">Your File</span>
              </div>
            </div>
          </div>
        </Col>
        {url && (
          <Col
            xs={12}
            sm={12}
            md={url ? 6 : 12}
            className="order-2 order-xs-2 text-center"
          >
            <div className="convert_select_area">
              <div
                className="con_select_panel d-flex  align-items-center "
                style={{ height: "90px" }}
              >
                <Fade
                  className={fileLink ? "fadeIn " : "fadeOut "}
                  in={fileLink}
                  unmountOnExit={!fileLink}
                >
                  <div className="url_bx_overlay">
                    <span className="url_dismiss" onClick={closeUrlEvent}>
                      <img src={cross_icn} alt="Cross Icon" />
                    </span>
                    <div className="url_txt_bx">
                      <h3>
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            className="mx-1"
                            viewBox="0 0 24 24"
                          >
                            <g transform="translate(-6.353 -6.085)">
                              <path
                                d="M17.6,24.32l-2.46,2.44a4,4,0,0,1-5.62,0,3.92,3.92,0,0,1,0-5.55l4.69-4.65a4,4,0,0,1,5.62,0,3.86,3.86,0,0,1,1,1.71A2,2,0,0,0,21.1,18l1.29-1.28a5.89,5.89,0,0,0-1.15-1.62,6,6,0,0,0-8.44,0L8.1,19.79a5.91,5.91,0,0,0,0,8.39,6,6,0,0,0,8.44,0l3.65-3.62h-.5a8,8,0,0,1-2.09-.24Z"
                                transform="translate(0 0.17)"
                                fill="#fff"
                              />
                              <path
                                d="M28.61,7.82a6,6,0,0,0-8.44,0l-3.65,3.62h.49a8,8,0,0,1,2.1.28l2.46-2.44a4,4,0,0,1,5.62,0,3.92,3.92,0,0,1,0,5.55L22.5,19.48a4,4,0,0,1-5.62,0,3.86,3.86,0,0,1-1-1.71,2,2,0,0,0-.28.23l-1.29,1.28a5.89,5.89,0,0,0,1.15,1.62,6,6,0,0,0,8.44,0l4.69-4.65a5.92,5.92,0,0,0,0-8.39Z"
                                transform="translate(0.02)"
                                fill="#fff"
                              />
                            </g>
                          </svg>
                        </span>
                        Enter Url
                      </h3>
                      <input
                        className="form-control "
                        type="url"
                        name="url"
                        value={urlImage || ""}
                        required
                        onChange={urlImageHandle}
                        placeholder="http://www.example.com/examplefile.jpg"
                      />
                    </div>
                  </div>
                </Fade>

                <div
                  className=" file_lnk d-flex justify-content-center align-items-center "
                  onClick={linkClickEvent}
                >
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      className="mx-1"
                    >
                      <g transform="translate(-6.353 -6.085)">
                        <path
                          d="M17.6,24.32l-2.46,2.44a4,4,0,0,1-5.62,0,3.92,3.92,0,0,1,0-5.55l4.69-4.65a4,4,0,0,1,5.62,0,3.86,3.86,0,0,1,1,1.71A2,2,0,0,0,21.1,18l1.29-1.28a5.89,5.89,0,0,0-1.15-1.62,6,6,0,0,0-8.44,0L8.1,19.79a5.91,5.91,0,0,0,0,8.39,6,6,0,0,0,8.44,0l3.65-3.62h-.5a8,8,0,0,1-2.09-.24Z"
                          transform="translate(0 0.17)"
                          fill="#fff"
                        />
                        <path
                          d="M28.61,7.82a6,6,0,0,0-8.44,0l-3.65,3.62h.49a8,8,0,0,1,2.1.28l2.46-2.44a4,4,0,0,1,5.62,0,3.92,3.92,0,0,1,0,5.55L22.5,19.48a4,4,0,0,1-5.62,0,3.86,3.86,0,0,1-1-1.71,2,2,0,0,0-.28.23l-1.29,1.28a5.89,5.89,0,0,0,1.15,1.62,6,6,0,0,0,8.44,0l4.69-4.65a5.92,5.92,0,0,0,0-8.39Z"
                          transform="translate(0.02)"
                          fill="#fff"
                        />
                      </g>
                    </svg>
                    Enter The Link
                  </span>
                </div>
              </div>
            </div>
          </Col>
        )}
      </Row>
    </>
  );
};

export default SmallScreen;
